export default __webpack_public_path__ + "static/media/icons.e20ed4c7.svg";